import * as React from 'react';

import { cn } from '@/components/atoms/primitives/utils';

/**
 * WEB-1001 — the design-system select (DS 1.9.0 `.a-select > .a-input`): a
 * native `<select>` on the text-field geometry
 * (40 fine / 44 coarse) with a drawn chevron. Native on purpose — the OS
 * picker is the accessible, touch-correct list on every platform.
 */
export interface SelectProps extends React.ComponentPropsWithoutRef<'select'> {
  invalid?: boolean;
  /** Class for the wrapping `.a-select` (layout: width, margins). */
  wrapperClassName?: string;
}

export const Select = React.forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { invalid, className, wrapperClassName, children, ...props },
  ref,
) {
  return (
    <span className={cn('a-select', wrapperClassName)}>
      <select
        ref={ref}
        {...props}
        aria-invalid={invalid || props['aria-invalid'] || undefined}
        className={cn('a-input', className)}
      >
        {children}
      </select>
    </span>
  );
});
